import React, { useRef, useState, useEffect } from "react";
import {
  Text,
  withSitecoreContext,
  RichText,
  isEditorActive,
} from "@sitecore-jss/sitecore-jss-react";
import "./index.scss";
import Slider from "react-slick";
import CarouselDots from "../../react-only-components/CarouselDots";
import CustomArrow from "../../react-only-components/CarouselArrow";
import { CarouselCardHighlightsModel } from "./models/CarouselCardHighlights.model";
import {
  CardHighlightsProps,
  CarouselCardHighlightsProps,
} from "./types/CarouselCardHighlights.types";
import { windowService } from "../../utils/window.utils";
import LazySection from "../../react-only-components/LazySection";
import useMediaQuery from "../../lib/custom-hooks/useMediaQuery";

const cardGenerator = (item: CardHighlightsProps, index: number) => {
  return (
    <div className="CarouselCardHighlights_wrapper" key={index}>
      <div className="CarouselCardHighlights__content">
        <Text
          tag="span"
          className="CarouselCardHighlights__title"
          field={item?.fields?.["Card Title"]}
        />

        <Text
          tag="h3"
          className="CarouselCardHighlights__text"
          field={item?.fields?.["Card Text"]}
        />
      </div>
    </div>
  );
};

const cardMapper = (props: CarouselCardHighlightsProps) => {
  const CarouselCardList = props?.fields?.["CarouselCardHighlightsLists"];
  const groupArray: JSX.Element[][] = [];
  // if(isTabpoint){
  //   let j =0;
  // for(let i = 1; i < CarouselCardList.length; i++) {
  //   let cardGroup = [];
  //   cardGroup.push(
  //     cardGenerator(CarouselCardList[i-1], i-1)
  //   );
  //   //cardGroup.push(cardGenerator(CarouselCardList[i-1], i-1));
  //   cardGroup.push(cardGenerator(CarouselCardList[i], i));
  //   groupArray.push(cardGroup);
  //   }
  // }

  let j = 0;
  if (CarouselCardList?.length) {
    for (let i = 2; i < (CarouselCardList?.length ?? 0); i++) {
      let cardGroup: JSX.Element[] = [];
      cardGroup.push(cardGenerator(CarouselCardList[i - 2], i - 2));
      cardGroup.push(cardGenerator(CarouselCardList[i - 1], i - 1));
      cardGroup.push(cardGenerator(CarouselCardList[i], i));
      groupArray.push(cardGroup);
    }
  }
  return groupArray.map((cardgroup, index) => {
    return (
      <div key={index} className="cardsmapper">
        {cardgroup}
      </div>
    );
  });
};

const CarouselCardHighlights = (props: CarouselCardHighlightsProps) => {
  const isEE = props.sitecoreContext?.pageEditing;
  const model = new CarouselCardHighlightsModel(props);
  const CarouselCardList = props?.fields?.["CarouselCardHighlightsLists"];
  const Autoscroll = props?.params?.["Autoscroll-Flag-Variations"];

  const scrollingspeed = props?.params?.["Number of seconds before scrolling"];
  const slidesAmount = CarouselCardList?.length;
  const isDesktop = useMediaQuery("(min-width: 900px)");
  const isTabpoint = useMediaQuery("(min-width: 430px)");
  const [sliderRef, setSliderRef] = useState<any>(null);
  //const slider = useRef<Slider | null>(null);
  const spp = scrollingspeed * 1000;

  const [showRightArrow, setshowRightArrow] = useState<boolean>(true);
  const [showLefttArrow, setshowLefttArrow] = useState<boolean>(false);

  const handleChangeSlide = (currentSlide: number) => {
    const leftArrowVisible = currentSlide != 0;
    // const rightArrowVisible = currentSlide <= CarouselCardList.length - maxNumberOfCardsToShow;
    const rightArrowVisible =
      currentSlide < ((CarouselCardList?.length ?? 0) - slideToShow);
    setshowLefttArrow(leftArrowVisible);
    setshowRightArrow(rightArrowVisible);
  };

  useEffect(() => {
    handleWidth();
  }, []);
  const handleWidth = () => {
    if (isEE || isEditorActive()) {
      let c = document && document.getElementsByClassName("slick-list");
      if (c && c.length > 0) {
        c[0].setAttribute("style", "width: auto !important");
      }
    }
  };

  const slideToShow = 3;
  const settings = {
    arrows: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: isEditorActive() || isEE ? true : false,
    autoplay: Autoscroll == "True" ? true : false,
    // speed: 300,
    autoplaySpeed: spp,
    // cssEase: "linear",
    nextArrow: showRightArrow ? (
      <CustomArrow
        direction="next"
        onClick={() => {
          sliderRef?.current?.slickNext();
        }}
      />
    ) : undefined,
    prevArrow: showLefttArrow ? (
      <CustomArrow
        direction="previous"
        onClick={() => {
          sliderRef?.current?.slickPrev();
        }}
      />
    ): undefined,

    afterChange: (currentSlide: number) => handleChangeSlide(currentSlide),
    customPaging: (_) => <CarouselDots />,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          arrows: false,
          slidesToShow: (CarouselCardList?.length ?? 0) < 3 ? 1 : 2,
          slidesToScroll: 1,
          touchMove: true,
        },
      },
      // {
      //   breakpoint: 768,
      //   settings: {
      //     arrows: false,
      //    slidesToShow: 1,
      //     slidesToScroll: 1,
      //   }
      // },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          // swipeToSlide: true,
          // swipe:true,
          touchMove: true,
        },
      },
      {
        breakpoint: 1680,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // use only in useEffect / functions that runs only client-side
  const getSlidesToShow = () => {
    const breakpointMd =
      windowService().matchMedia("(min-width: 450px)").matches;
    if (breakpointMd) {
      const breakpointLg = windowService().matchMedia(
        "(min-width: 1000px)"
      ).matches;
      if (breakpointLg) {
        return 4;
      }
      return 2;
    }
    return 1.2;
  };
  const cardGridWrapperRef = useRef(null);

  const activeClass = "slick-active";

  return (
    <LazySection>
      {props.fields && CarouselCardList && (
        <div
          className={"CarouselCardHighlights_root"}
          ref={cardGridWrapperRef}
          id={props?.rendering?.uid}
        >
          <Text
            tag="p"
            field={model.eyebrow}
            className={"CarouselCardHighlights__eyebrow"}
          />
          <Text
            tag="h3"
            field={model.title}
            className={"CarouselCardHighlights__toptitle"}
          />

          {CarouselCardList.length < 3 && isDesktop ? (
            <div className={"cardsmapperdesk"}>
              {CarouselCardList.map((item, i) => (
                <div className="CarouselCardHighlights_wrapper" key={i}>
                  <div className="CarouselCardHighlights__content">
                    <RichText
                      tag="span"
                      className="CarouselCardHighlights__title"
                      field={item?.fields?.["Card Title"]}
                    />

                    <RichText
                      tag="h3"
                      field={item?.fields?.["Card Text"]}
                      className="CarouselCardHighlights__text"
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <Slider ref={setSliderRef} {...settings}>
              {isDesktop
                ? cardMapper(props)
                : CarouselCardList.map((item, i) => (
                    <div className="CarouselCardHighlights_wrapper" key={i}>
                      <div className="CarouselCardHighlights__content">
                        <RichText
                          tag="span"
                          className="CarouselCardHighlights__title"
                          field={item?.fields?.["Card Title"]}
                        />

                        <RichText
                          tag="h3"
                          field={item?.fields?.["Card Text"]}
                          className="CarouselCardHighlights__text"
                        />
                      </div>
                    </div>
                  ))}
            </Slider>
          )}
        </div>
      )}
    </LazySection>
  );
};
export default withSitecoreContext()(CarouselCardHighlights);
